<template>
	<v-dialog v-model="dialog" width=" 500">
		
		<v-card outlined>
			<v-card-text>
				
				<v-row
					no-gutters
				>
					<template 
						v-for="(item_modal, idx_modal) of info"
					>					
						<v-col 
							:key="idx_modal"
							md="4"
						>	
						<!-- <template v-for="test of item_modal.split(',')"> -->
							
							<span >							
								{{ item_modal }}
							</span>
						<!-- </template> -->
						
							<!-- <v-card v-if="is_list">
								<v-card-title
									class="pa-0 secondary"
								>
									{{ item_modal }}
								</v-card-title>
								<v-card-text>
									<v-row>
										<template v-for="(item_sub, idx_sub) of item_modal">											
											<v-col
												:key="idx_sub"
											>
												
												
											</v-col>
										</template>
									</v-row>
								</v-card-text>
							</v-card> -->
						</v-col>
					</template>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
	export default{
		name: 'show_modal',
		props: [
			'info_to_component',
		],
		data: () => ({
			info: {},
			dialog: false,
			is_list: false,
		}), // data
		created(){
			console.log('create show modal')
		}, 
		watch:{
			info_to_component: function(val){
				console.log(val, 'open modal')
				if (val) {
					this.dialog = true;
					// console.log(typeof val == 'string', typeof val == 'object', JSON.stringify(val))  
					// val = Object.values(val)
					val = JSON.stringify(val, null, 2)
					console.log( typeof val == 'string', typeof val == 'object')

					val = val.replaceAll(/"/ig, '');
					val = val.replaceAll('{', '');
					val = val.replaceAll(':', ' : ');
					val = val.replaceAll('[', '');
					val = val.replaceAll(']', '');
					val = val.replaceAll('}', ''); //
					// val = val.replaceAll('', ''); 
					val = val.split(',')
					// val = val.replaceAll(',', ' ');

					/*		if (sub == '"' || sub == "{" ||  sub == "}") {
								if (sub == "}") {
									// val.splice(idx_let, 1, "\n");
									sub = "\n";
								}else{
									// val.splice(idx_let, 1);
									sub = "";
								}
							}
					*/
					this.info = val ; //Object.values(val);
				}
			}, // info to component

			dialog: function(val){
				if (!val) {
					this.$emit('close_component', null);
				}
			}
		}, // watch

	}
</script>